<template>
    <rkm-area
        class="mt-3"
        title="Exames"
        type="fieldset"
    >
        <rkm-button
            @click="$refs.Modal.open()"
            color="primary"
            slot="trailing"
            small
            title="Adicionar"
        >
            <rkm-icon icon="plus" />
        </rkm-button>

        <List :model="model" />

        <Modal
            :form="form"
            :model="model"
            ref="Modal"
        />
    </rkm-area>
</template>

<script>
// Components.
import List from './List.vue'
import Modal from './Modal.vue'

export default {
    components: {
        List,
        Modal,
    },
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
};
</script>
